<fm-context-menu
  [position]="menuData.clickPosition"
  [isRightClickDisabled]="true"
  class="map-menu-container"
  (closed)="onMenuClosed()"
  (copyCoordinatesClicked)="onCopyCoordinates($event)"
  [menuName]="menuData.markerInfo.title"
  [latLng]="menuData.markerInfo?.latLng"
>
  <fm-context-menu-panel>
    <fm-context-menu-item
      [hasSeparator]="true"
      (click)="onFindNearestClicked()"
      *ngIf="userPermissions.findNearest"
      a7s-id="live-map-asset-contextual-menu-find-nearest"
    >
      <a i18n="@@S_FIND_NEAREST">Find nearest</a>
    </fm-context-menu-item>
    <fm-context-menu-item
      *ngIf="userPermissions.viewReplay"
      id="lnk-asset-view-replay"
      (click)="onViewReplayClicked()"
      a7s-id="live-map-asset-contextual-menu-view-replay"
    >
      <a i18n="@@S_VIEW_REPLAY">View replay</a>
    </fm-context-menu-item>
    <fm-context-menu-item
      *ngIf="userPermissions.locationHistory"
      [hasSeparator]="true"
      id="lnk-asset-location-history"
      (click)="onLocationHistoryClicked()"
      a7s-id="live-map-asset-contextual-menu-location-history"
    >
      <a i18n-text="@@S_LOCATION_HISTORY">Location History</a>
    </fm-context-menu-item>
    <fm-context-menu-item (click)="onZoomToClicked()" a7s-id="live-map-asset-contextual-menu-zoom-to">
      <a i18n="@@S_ZOOM_TO">Zoom to</a>
    </fm-context-menu-item>
    <fm-context-menu-item
      (click)="onStreetViewClicked()"
      [isDisabled]="!menuData.streetViewAvailable"
      a7s-id="live-map-asset-contextual-menu-street-view"
    >
      <a i18n="@@S_STREET_VIEW">Street view</a>
    </fm-context-menu-item>
    <fm-context-menu-item
      (click)="onCreateGeofenceClicked()"
      *ngIf="userPermissions.createGeofence"
      a7s-id="live-map-asset-contextual-menu-create-geofence"
    >
      <a i18n="@@S_CREATE_A_GEOFENCE_HERE">Create a Geofence here</a>
    </fm-context-menu-item>
    <fm-context-menu-item *ngIf="userPermissions.directions" a7s-id="live-map-asset-contextual-menu-directions">
      <a i18n="@@S_DIRECTIONS">Directions</a>
      <fm-context-menu-panel>
        <fm-context-menu-item (click)="onGetDirectionToClicked()" a7s-id="live-map-asset-contextual-menu-directions-get-directions-to-here">
          <a i18n="@@S_GET_DIRECTIONS_TO_HERE">Get Directions to here</a>
        </fm-context-menu-item>
        <fm-context-menu-item (click)="onGetDirectionFromClicked()" a7s-id="live-map-asset-contextual-menu-get-directions-from-here">
          <a i18n="@@S_GET_DIRECTIONS_FROM_HERE">Get Directions from here</a>
        </fm-context-menu-item>
      </fm-context-menu-panel>
    </fm-context-menu-item>
    <fm-context-menu-item
      *ngIf="userPermissions.manageAssets"
      a7s-id="live-map-asset-contextual-menu-manage-assets-edit-assets"
      (click)="onEditAssetClicked()"
    >
      <a i18n="@@S_LIVE_MAP_CONTEXT_MENU_EDIT" *ngIf="!fleetAndDeviceListFeatureToggleEnabled">Edit</a>
      <a i18n="@@S_VIEW_ASSET" *ngIf="fleetAndDeviceListFeatureToggleEnabled">View Asset</a>
    </fm-context-menu-item>
    <fm-context-menu-item
      *ngIf="isPingMVPEnabled"
      id="lnk-asset-troubleshoot-asset"
      (click)="onTroubleshootAssetClicked()"
      a7s-id="live-map-asset-contextual-menu-device-health-check"
    >
      <a i18n="@@S_DEVICE_HEALTH_CHECK">Device Health Check</a>
    </fm-context-menu-item>
  </fm-context-menu-panel>
</fm-context-menu>
